import React, { useState } from "react";
import { Pie } from 'react-chartjs-2';
import { Modal, Button } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import 'chartjs-plugin-piechart-outlabels';


function GetQRNonQRDataFunc({ totalAllocated, updatedData }) {
  const updatedTotalAllocated = {
    labels: totalAllocated.labels,
    datasets: [{
      data: [updatedData.usedStatus, (updatedData.totalAllocated - updatedData.usedStatus)],
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    pieChart: totalAllocated.pieChart,
    QRCount: [updatedData.usedStatus, updatedData.downloadedStatus, updatedData.totalAllocated]
  };

  const updatedTotalAllocatedUnUsedQR = {
    labels: totalAllocated.labels,
    datasets: [{
      data: [(parseInt(updatedData.downloadedStatus) + parseInt(updatedData.issuedStatus)), (updatedData.totalAllocated - updatedData.usedStatus)],
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    pieChart: totalAllocated.pieChart,
  };

  const updatedTotalAllocatedProductsCategories = {
    labels: updatedData.data1,
    datasets: [{
      data: updatedData.data2,
      backgroundColor: totalAllocated.datasets[0].backgroundColor,
      hoverBackgroundColor: totalAllocated.datasets[0].hoverBackgroundColor
    }],
    text: totalAllocated.text,
    height: totalAllocated.height,
    type: totalAllocated.type,
  };

  const options = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'left'
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    pieceLabel: [
      {
        render: 'percentage',
        fontStyle: 'bold',
        fontColor: '#000',
        position: 'outside'
      }],
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
        }
      }
    }
  }

  const productCategoryOptions = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'left',
      labels: { fontSize: 12 }
    },
    layout: {
      padding: 90
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    plugins: {
      datalabels: {
        display: false,
        outlabels: {
          text: '%l %p',
          color: 'white',
          stretch: 100,
          font: {
            resizable: true,
            minSize: 12,
            maxSize: 18
          }
        }
      }
    }
  }

  const firstOptions = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'left',
      labels: {
        fontSize: 12
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    pieceLabel: [{
      render: 'percentage',
      fontStyle: 'bold',
      fontColor: '#000',
      position: 'outside'
    }],
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
        },
      },
      outlabels: false
    }
  }

  const fourthOptions = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      position: 'left',
      labels: {
        fontSize: 12
      }
    },
    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    pieceLabel: [{
      render: 'percentage',
      fontStyle: 'bold',
      fontColor: '#000',
      position: 'outside'
    }],

    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
        },
      },
      outlabels: false
    }
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (totalAllocated.pieChart == 'first') {
    return (
      <>
        <Pie data={updatedTotalAllocated} options={firstOptions} onElementsClick={handleShow} />
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Used QR VS Unused QR - Overall</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Used QR Codes</th>
                  <th scope="col">Unused QR Codes</th>
                  <th scope="col">Total QR Codes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td><NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={updatedData.usedStatus} /></td>
                  <td><NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={(updatedData.totalAllocated - updatedData.usedStatus)} /></td>
                  <td><NumberFormat displayType={'text'} thousandSeparator={true} thousandsGroupStyle="lakh" value={updatedData.totalAllocated} /></td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
              </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
  else if (totalAllocated.pieChart == 'fourth') {
    return (
      <Pie data={updatedTotalAllocatedUnUsedQR} options={fourthOptions} />
    )
  }
  else if (totalAllocated.type == 'productCategories') {
    return (
      <Pie data={updatedTotalAllocatedProductsCategories} options={productCategoryOptions} />
    )
  }
  else {
    return (
      <Pie data={totalAllocated} options={options} />
    )
  }
}
const PieChartGraph = (props) => {
  return <GetQRNonQRDataFunc updatedData={props.updatedData} totalAllocated={props.totalAllocated} />;
}

export default PieChartGraph;